<div class="signup-wrap">
  <div class="signup-wrap__inner">
    <div class="signup signup--checkout">
      <app-plan [planType]="planType" [highlighted]="true" [selected]="true"></app-plan>
      <form [formGroup]="form" (ngSubmit)="onSubmit(action)" class="signup__form">
        <div class="signup__form-inner">
          <h2 class="signup__form-title">Get Started</h2>
          <p class="signup__form-text">Whether you are looking to start a new line of business, invest in an innovative
            marketing strategy, or evaluate your financial institution’s performance, Lakehouse Analytics will give you
            the data you need to make effective decisions.</p>
          <div class="signup__fields">
            <div class="signup__field">
              <label for="firstName">First Name</label>
              <input #firstNameInput type="text" formControlName="firstName">
              @if (form.controls.firstName.invalid && (form.controls.firstName.dirty ||
              form.controls.firstName.touched)){
              <div class="signup__error">
                @if (form.controls.firstName.errors?.['required']) {
                <div>
                  First Name is required.
                </div>
                }
              </div>
              }
            </div>
            <div class="signup__field">
              <label for="lastName">Last Name</label>
              <input type="text" formControlName="lastName">
              @if (form.controls.lastName.invalid && (form.controls.lastName.dirty || form.controls.lastName.touched)){
              <div class="signup__error">
                @if (form.controls.lastName.errors?.['required']) {
                <div>
                  Last Name is required.
                </div>
                }
              </div>
              }
            </div>
          </div>
          <div class="signup__fields">
            <div class="signup__field">
              <label for="phone">Phone</label>
              <input type="text" mask="000-000-0000" formControlName="phone">
              @if (form.controls.phone.invalid && (form.controls.phone.dirty || form.controls.phone.touched)) {
              <div class="signup__error">
                @if (form.controls.phone.errors?.['required']) {
                <div>
                  Phone is required.
                </div>
                }
                @if (form.controls.phone.errors?.['mask']) {
                <div>
                  Phone must be 10 digits.
                </div>
                }
              </div>
              }
            </div>
            <div class="signup__field">
              <label for="title">Job Title</label>
              <input type="text" formControlName="title">
              @if (form.controls.title.invalid && (form.controls.title.dirty || form.controls.title.touched)) {
              <div class="signup__error">
                @if (form.controls.title.errors?.['required']) {
                <div>
                  Title is required.
                </div>
                }
              </div>
              }
            </div>
          </div>
          <div class="signup__field">
            <label for="email">Email</label>
            <input type="email" formControlName="email">
            @if (form.controls.email.invalid && (form.controls.email.dirty || form.controls.email.touched)) {
            <div class="signup__error">
              @if (form.controls.email.errors?.['required']) {
              <div>
                Email is required.
              </div>
              }
              @if (form.controls.email.errors?.['pattern']) {
              <div>
                Email enter a valid email address. Contact <a href="mailto:support@lakehouse-analytics.com"
                  target="_blank">LakeHouse Analytics support</a> with any questions.
              </div>
              }
              @if (form.controls.email.errors?.['emailExists']) {
              <div>
                Email is already in use. Please contact <a href="mailto:support@lakehouse-analytics.com"
                  target="_blank">LakeHouse Analytics support</a> with any questions.
              </div>
              }
              @if (form.controls.email.errors?.['restrictedDomain']) {
              <div>
                Please use a valid work email address. Contact <a href="mailto:support@lakehouse-analytics.com"
                  target="_blank">LakeHouse Analytics support</a> with any questions.
              </div>
              }
            </div>
            }
          </div>
          <div class="signup__field">
            <label for="institution">Institution</label>
            <div class="signup__inst">
              <input #institutionInput type="text" formControlName="institution" [readonly]="lockInstitution">
              <input type="hidden" formControlName="institutionIid" />
              <div (click)="clearInstitution()" class="signup__inst-clear">Clear Selection <svg
                  class="icon signup__inst-clear-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path
                    d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                </svg></div>
            </div>
            @if (form.controls.institutionIid.invalid && (form.controls.institution.dirty ||
            form.controls.institution.touched)) {
            <div class="signup__error">
              @if (form.controls.institutionIid.errors?.['required']) {
              <div>
                Institution is required.
              </div>
              }

            </div>
            }
            @if (institutionExistsInfo && institutionHasSignUpProduct) {
            <div class="info-message">
              Your institution already has an account. Please register.
            </div>
            }
            @else if(institutionExistsInfo && !institutionHasSignUpProduct) {
            <div class="info-message">
              Your organization currently has an active LakeHouse Analytics subscription,
              but the {{planLabel}} product is not included in your plan.
              To request access, please contact your system administrator or reach out to LakeHouse Analytics
              Support at <a href="mailto:support@lakehouse-analytics.com">support&#64;lakehouse-analytics.com</a>.
              We're happy to assist!
            </div>
            }
          </div>
          @if (planType == 'PeerComparisonStandard') {
          <div class="signup__field">
            <label for="promoCode">Promo Code</label>
            <input type="text" formControlName="promoCode">
            @if (form.controls.promoCode.invalid && (form.controls.promoCode.dirty || form.controls.promoCode.touched))
            {
            <div class="signup__error">
              @if (form.controls.promoCode.errors?.['required']) {
              <div>
                Promo code is required.
              </div>
              }
              @if (form.controls.promoCode.errors?.['invalid']) {
              <div>
                Invalid promo code.
              </div>
              }
            </div>
            }
          </div>
          }
          <div [hidden]="institutionExistsInfo || (form.controls.promoCode.value && form.controls.promoCode.valid)">
            <div class="signup__field">
              <label for="subscription">Subscription</label>
              <select formControlName="subscription">
                <option value="">Please select subscription</option>
                @for (subscription of subscriptions; track subscription.id) {
                <option value="{{ subscription.id }}">
                  {{ subscription.display }}
                </option>
                }
              </select>
              @if (form.controls.subscription.invalid && (form.controls.subscription.dirty ||
              form.controls.subscription.touched)) {
              <div class="signup__error">
                @if (form.controls.subscription.errors?.['required']) {
                <div>
                  Subscription is required.
                </div>
                }
              </div>
              }
            </div>

            <div class="signup__field">
              <label for="pay">Payment</label>
              <div id="card-element"></div>
              <div id="card-element-errors" role="alert" class="signup__error">{{ cardError }}</div>
            </div>
          </div>

          <!-- Register for exisitng organization -->
          @if(institutionExistsInfo && institutionHasSignUpProduct){
          <button class="button" type="submit"
            [disabled]="(!form.controls.email.valid || !form.controls.firstName.valid
          || !form.controls.lastName.valid || !form.controls.phone.valid || !form.controls.title.valid) || submitDisabled"
            (click)="action='register'">Register Now</button>
          }

          <!-- Regular sign up -->
          <div [hidden]="institutionExistsInfo || (form.controls.promoCode.value && form.controls.promoCode.valid)">
            <button class="button" type="submit" [disabled]="!form.valid || submitDisabled"
              (click)="action='signUp'">Signup Now</button>
          </div>

          <!-- promo code signup -->
          @if(form.controls.promoCode.value && !institutionExistsInfo && form.controls.promoCode.valid){
          <button class="button" type="submit"
            [disabled]="(!form.controls.promoCode.touched || !form.controls.email.valid || !form.controls.firstName.valid || !form.controls.promoCode.valid 
          || !form.controls.lastName.valid || !form.controls.phone.valid || !form.controls.title.valid  || !form.controls.institutionIid.valid) || submitDisabled"
            (click)="action='promo'">Signup</button>
          }

        </div>
      </form>
    </div>
  </div>
</div>